import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyTeamCalendarSiteSettingsPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TeamCalendarSiteSettingsPage" */ './site-settings/TeamCalendarSiteSettingsPage.tsx'
			)
		).TeamCalendarSiteSettingsPage,
});
